/**
 * Per-award sleepover-disturbance rules dispatch.
 *
 * The approve/pay-run paths used
 * `award === MA000018 ? AGED_CARE : SCHADS`. Nurses (MA000034) and HPSS
 * (MA000027) have no sleepover clause; that else-branch invented an
 * entitlement. The third branch is refusal, not a copy of SCHADS.
 *
 * Artifact:
 * docs/operations/clause-verifications/2026-08-15-aged-care-legislation-disturbance-award-dispatch.md
 */
import { AGED_CARE_DISTURBANCE_RULES } from './aged-care';
import { SCHADS_DISTURBANCE_RULES } from './schads';
import type { DisturbanceRules } from '../award-engines/disturbance';

export const DISTURBANCE_AWARD_RULES_VERSION = '1.0.0';

export function normalisedAwardCode(awardCode: string | null | undefined): string {
  return (awardCode ?? '').trim().toUpperCase();
}

export function disturbanceRulesForAward(
  awardCode: string | null | undefined,
): DisturbanceRules | null {
  const code = normalisedAwardCode(awardCode);
  if (code === 'MA000018') return AGED_CARE_DISTURBANCE_RULES;
  if (code === 'MA000100') return SCHADS_DISTURBANCE_RULES;
  return null;
}

export function disturbanceRulesUnsupportedReason(awardCode: string | null | undefined): string {
  const code = normalisedAwardCode(awardCode) || '(missing)';
  if (code === 'MA000034') {
    return `Award ${code} does not support sleepover disturbance pay (Nurses Award MA000034 has no sleepover clause).`;
  }
  if (code === 'MA000027') {
    return `Award ${code} does not support sleepover disturbance pay (HPSS Award MA000027 has no sleepover clause).`;
  }
  return `Award ${code} does not support sleepover disturbance pay (Aged Care + SCHADS only).`;
}
